import React, { useEffect } from 'react';

import { Tooltip } from 'bootstrap';

import moment from 'moment';
import { DateTime } from '../../analytics/reports/dateTime';
import { getLanguage } from '../../../locales/language';
import { getDateTimeFormated } from '../../utils/dates/utils';
const IGImageCard = ({ src, status, mediaTypeVideo, date, uuid }) => {
  const listedStatus = [
    { name: 'Draft', statNum: 2, color: 'bg-warning' },
    { name: 'Approval', statNum: 3, color: 'bg-info' },
    { name: 'Planned', statNum: 4, color: 'bg-primary' },
    { name: 'Published', statNum: 5, color: 'bg-success' }
  ];

  const renderTooltip = `<div class="tooltip" role="tooltip"><div class="badge bg-white mx-1 float-right ">
      <div>
        <i class="fa-duotone fa-timer"></i>
      </div>
      <span class="text-muted ms-1 " style={{ fontSize: 9 }}>
        ${getDateTimeFormated(date)}
      </span>
    </div></div>`;

  useEffect(() => {
    const tooltipTrigger = document.querySelector(`.tooltip-trigger-${uuid}`);
    tooltipTrigger &&
      new Tooltip(tooltipTrigger, {
        title: 'title',
        placement: 'top',
        trigger: 'hover',
        container: 'body',
        template: renderTooltip
      });
  }, []);

  return (
    <div
      className={`tooltip-trigger-${uuid} border border-white border-1`}
      style={{ width: '33%' }}
      data-bs-toggle="tooltip"
    >
      <div
        style={{ aspectRatio: 0.8, paddingBottom: '1px' }}
        className="position-relative"
      >
        {' '}
        {mediaTypeVideo && (
          <div
            style={{
              width: '32px',
              height: '32px'
            }}
            className="position-absolute top-0 end-0  pt-1"
          >
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.0753 12.8928C12.418 12.5337 11.6137 12.998 11.5961 13.7468L11.4743 18.9189C11.4559 19.699 12.2982 20.1986 12.974 19.8085L17.6359 17.117C18.3116 16.7268 18.3001 15.7475 17.6153 15.3734L13.0753 12.8928Z"
                fill="#ffffff"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 3C6.13401 3 3 6.13401 3 10V18C3 21.866 6.13401 25 10 25H18C21.866 25 25 21.866 25 18V10C25 6.13401 21.866 3 18 3H10ZM18 5H17.2392L17.8321 5.98816L19.0704 8.11112H22.6309C21.8857 6.28608 20.0931 5 18 5ZM10.8488 5H14.9069L16.1076 7.00124L16.755 8.11112H12.6829L11.5464 6.16277L10.8488 5ZM5.36909 8.11112C5.94518 6.7002 7.14733 5.6114 8.63033 5.18992L9.8219 7.17588L10.3675 8.11112H5.36909ZM5 18V10.1111H11.5341L11.5449 10.1296L11.5765 10.1111H23V18C23 20.7614 20.7614 23 18 23H10C7.23858 23 5 20.7614 5 18Z"
                fill="#ffffff"
              />
            </svg>
          </div>
        )}
        <div className="position-absolute d-flex align-items-center gap-1 bottom-0 end-0 m-1">
          <div
            style={{
              width: '14px',
              height: '14px'
            }}
            className={`rounded-circle ${
              listedStatus.filter((item) => item.statNum === status)[0]
                ?.color || ''
            }`}
          ></div>

          <div
            className=" bg-light text-muted rounded-3 "
            style={{ fontSize: '10px', padding: '2px' }}
          >
            {moment(date).format('DD/MM')}
          </div>
        </div>
        <img
          className="w-100 h-100"
          style={{
            objectFit: 'cover',
            outline: status === null ? '3px dashed #FFC700' : 'none'
          }}
          src={src}
        />
      </div>
    </div>
  );
};

export default IGImageCard;
